import { composeIO } from 'react-compose-io'
import { transitoBoxIO } from './TransitoBox.IO'
import { TransitoBoxView } from './TransitoBox.View'

export const TransitoBox = composeIO(TransitoBoxView, transitoBoxIO)
